import { useQuery } from '@apollo/client';
import { CurrentUserReferralsInfoDocument } from '../graphql/generated';
import { dt } from '../util/dateTime';
import { useFinancialEntities } from './financialEntities';
import { useCurrentUser } from './user';

// Referrals enabled if
// 1. User has at least one linked financial entity and
// 2. User has been a member for more than 30 days
// OR if user has already completed at least one referral
export const useShowReferrals = (): { enabled: boolean; loading: boolean } => {
    const { userInfo } = useCurrentUser();
    const { unfilteredData } = useFinancialEntities();
    const { data } = useQuery(CurrentUserReferralsInfoDocument);
    const referralsInfo = data?.currentUserReferralsInfo;

    if (!userInfo || !unfilteredData) return { enabled: false, loading: true };

    const hasLinkedFE = unfilteredData.financialEntities.some(
        (fe) =>
            fe.linkStatus === 'PLAID_CONNECTED' ||
            fe.linkStatus === 'MONEY_KIT_CONNECTED' ||
            fe.linkStatus === 'PLAID_ERROR' ||
            fe.linkStatus === 'MONEY_KIT_ERROR'
    );

    const hasBeenMemberForMoreThan30Days =
        dt().diff(dt(userInfo.createdAt), 'day') > 30;

    const enabled =
        (referralsInfo?.paidReferrals && referralsInfo?.paidReferrals > 0) ||
        (hasLinkedFE && hasBeenMemberForMoreThan30Days);

    return { enabled, loading: false };
};
